import { mdiInformation, mdiInformationOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { CSSProperties, memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import type { IconProps } from '../../../Icons'
import Container from '../Container'

const InfoIcon = memo((props: IconProps) => {
    const { filled } = props
    return (
        <Icon
            path={filled ? mdiInformation : mdiInformationOutline}
            size={1}
            {...props}
        />
    )
})

interface InfoButtonProps {
    styleOverrides?: CSSProperties
    size?: number
    shadow?: boolean
    title?: string
    onClick: any
}

const InfoButton = memo((props: InfoButtonProps) => {
    const { styleOverrides, shadow = true, title, onClick, size } = props
    return (
        <Container shadow={shadow} title={title}>
            <IconButton
                data-testid="IconButton__InfoButton"
                style={styleOverrides}
                onClick={onClick}
            >
                <InfoIcon color="#eee" size={size} />
            </IconButton>
        </Container>
    )
})

export default InfoButton
